<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="title">THE WITNESS ON THE ROOF</p>
<p class="authora">Annie Haynes</p>
<div class="image_container">
<img alt="image" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?09618cbc